module.exports = __webpack_public_path__ + "img/nonemessage.ecbb57f4.png";